/**
 * A shortlived class that manages one tween.
 */
export default class Animator {
    /**
     * Tween duration
     * @type {Number}
     */
    static DURATION = 350

    /**
     * Current requestAnimationFrame id
     * @type {Number}
     */
    raf

    /**
     * Whether the Animator is currently active or not
     * @type {Boolean}
     */
    isActive

    easing = (t) => t

    onEnd = () => []

    duration = Animator.DURATION

    constructor(from, to, callback) {
        this.from = from
        this.to = to
        this.onUpdate = callback
        this.value = 0
    }

    start = () => {
        this.startTime = document.timeline.currentTime
        this.raf = requestAnimationFrame(this.update)
    }

    /**
     * Callback for requestAnimationFrame that calculates the tween amount and
     * runs the user-supplied callback.
     * @param {DOMHighResTimeStamp} time
     */
    update = (time) => {
        const delta = time - this.startTime
        if (delta > this.duration) {
            this.cancel()
            return
        }

        this.isActive = true

        const factor = this.easing(delta / Animator.DURATION)

        this.value = (factor * (this.to - this.from)) + this.from

        this.onUpdate(this.value)
        this.raf = requestAnimationFrame(this.update)
    }

    /**
     * Ends the animation prematurely
     */
    cancel = () => {
        this.isActive = false
        cancelAnimationFrame(this.raf)
        this.onEnd()
    }
}
